import { render, staticRenderFns } from "./EnablePersistExtensionsSettings.vue?vue&type=template&id=6c669ca8"
import script from "./EnablePersistExtensionsSettings.vue?vue&type=script&lang=js"
export * from "./EnablePersistExtensionsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports